import { render, staticRenderFns } from "./bandeira.vue?vue&type=template&id=1bf7ed9e&"
import script from "./bandeira.vue?vue&type=script&lang=js&"
export * from "./bandeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports